import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 25 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M3.5 13.3335V18.3335C3.5 18.7755 3.67559 19.1994 3.98816 19.512C4.30072 19.8246 4.72464 20.0002 5.16667 20.0002H20.1667C20.6087 20.0002 21.0326 19.8246 21.3452 19.512C21.6577 19.1994 21.8333 18.7755 21.8333 18.3335V13.3335',
                    stroke: '#757575',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M20.791 9.73519C21.4336 9.38473 21.8333 8.71129 21.8333 7.9794V6.66667C21.8333 6.22464 21.6577 5.80072 21.3452 5.48816C21.0326 5.17559 20.6087 5 20.1667 5H5.16667C4.72464 5 4.30072 5.17559 3.98816 5.48816C3.67559 5.80072 3.5 6.22464 3.5 6.66667V7.9794C3.5 8.71129 3.89977 9.38473 4.5423 9.73519L12.6667 14.1667L20.791 9.73519Z',
                    stroke: '#757575',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const MailOutlined = React.forwardRef(IconComponent);
MailOutlined.displayName = 'MailOutlined';

export { MailOutlined };
